class VideoSteps implements ng.IComponentController {
    steps: anm.VideoStep[];
    reverse: boolean;
    videoPlayerSettings = {
        autoplay: true,
        isIcon: false
    };
}

angular.module('animatronApp.videoSteps', []).component('videoSteps', {
    bindings: {
        steps: '<',
        reverse: '<'
    },
    controller: VideoSteps,
    templateUrl: require('video-steps.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/videoSteps.ts